require('../../modules/es.object.values');
var path = require('../../internals/path');

module.exports = path.Object.values;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/es/object/values.js
// module id = 1642
// module chunks = 1